import * as Yup from 'yup';

export const PermissionGroupValidationSchema = Yup.object({
  name: Yup.string()
    .trim()
    .required('Name of the Group is Required')
    .max(40, 'Max length is 40 characters'),
  // idArray: Yup.array()
  //   .min(1, 'Please select at least one Permission')
  //   .required('Please Select Permissions'),
});
